import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    badgeLabel: {
      APPROVED: 'Creation in progress',
      PENDING: 'Waiting for approval',
    },
    limitDescription: '{amount} of {maxAmount}',
    paymentLimit: 'Payment limits',
  },
  fr: {
    badgeLabel: {
      APPROVED: 'En cours de création',
      PENDING: 'En attente d’acceptation',
    },
    limitDescription: '{amount} sur {maxAmount}',
    paymentLimit: 'Plafond de paiement',
  },
} as const);

export default locales;
